import React, { useEffect, useState } from 'react';

import { EVENTS } from 'consts/metricsTrackingEvents';
import { trackEvent, identifyUser } from 'utils/metricsTracking';
import APP_URLS from 'consts/appUrls';
import {
  CTA_UNLOCK_YOUR_OFFER,
  DISCLAIMER_CONSULTATION_CANCEL,
} from 'consts/copy';

import {
  AnimationWrapper,
  Disclaimer,
  Title,
  LinkButtonStyled,
} from './StickyCta.style';

export interface StickyCtaProps {
  buttonTextOverride?: string;
  disclaimerTextOverride?: string;
}

export const StickyCta = ({
  buttonTextOverride,
  disclaimerTextOverride,
}: StickyCtaProps) => {
  const moduleName = 'stickyCta';

  const [ctaButtonButtonObserved, setCtaButtonObserved] = useState(false);
  const [moduleObserved, setModuleObserved] = useState(true);

  const onCtaClick = () => {
    identifyUser({
      patient: {},
      traits: {},
      callback: () => {
        trackEvent(EVENTS.ctaClicked, {
          path: window.location.pathname,
          module: moduleName,
        });
      },
    });
  };

  useEffect(() => {
    if (window.IntersectionObserver) {
      const elementsList = document.querySelectorAll("[id*='ctaButton']");
      // changing linked list to array and flipping order so it starts the check from bottom up
      const elementsArray = [...elementsList];
      const elementsArrayReverse = elementsArray.reverse();

      const modulesList = document.querySelectorAll("[id*='hero'], footer");
      // changing linked list to array and flipping order so it starts the check from bottom up
      const modulesArray = [...modulesList];
      const modulesArrayReverse = modulesArray.reverse();

      const createObserver = (observerType: 'element' | 'module') => {
        return new window.IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (observerType === 'element') {
                setCtaButtonObserved(entry.isIntersecting);
              } else {
                setModuleObserved(entry.isIntersecting);
              }
            });
          },
          {
            threshold: 0.1,
            rootMargin: observerType === 'module' ? '50px' : '0px',
          },
        );
      };

      const elementsObserver = createObserver('element');
      elementsArrayReverse.forEach((element) => {
        elementsObserver.observe(element);
      });

      const moduleObserver = createObserver('module');
      modulesArrayReverse.forEach((module) => {
        moduleObserver.observe(module);
      });
    }
  }, []);

  return (
    <AnimationWrapper
      data-module={moduleName}
      showStickyCta={!ctaButtonButtonObserved && !moduleObserved}
    >
      {!ctaButtonButtonObserved && !moduleObserved && (
        <LinkButtonStyled
          href={APP_URLS.welcome}
          onClick={onCtaClick}
          buttonType="primary"
        >
          <Title>{buttonTextOverride || CTA_UNLOCK_YOUR_OFFER}</Title>
          <Disclaimer>
            {disclaimerTextOverride || DISCLAIMER_CONSULTATION_CANCEL}
          </Disclaimer>
        </LinkButtonStyled>
      )}
    </AnimationWrapper>
  );
};
